import React from "react";
import { Button, Select, Grid, Spin } from "antd";
import "@/assets/less/dashboard-table.less";

export const RightTabs = ({
  activeTabKey,
  rightTabsRef,
  onChange,
  tabCounts,
  cartCountLoading = false,
  noFavouriteTab = false,
}) => {
  // Detect mobile viewport
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  const rightTabsOptions = [
    {
      key: "2",
      label: "Cart",
      count: tabCounts[2] || 0,
      icon: "ri-shopping-basket-line",
      loading: cartCountLoading,
    },
    !noFavouriteTab && {
      key: "3",
      label: "Favourites", 
      count: tabCounts[3] || 0,
      icon: "ri-star-line",
      loading: false,
    },
  ].filter(Boolean);

  return (
    <div ref={rightTabsRef} className="right-tabs top-dashboard-panel">
      {isMobile ? (
        <Select
          size="small"
          value={activeTabKey}
          onChange={onChange}
          options={rightTabsOptions.map((item) => ({
            label: (
              <span className="display-center" style={{ gap: "6px" }}>
                <i className={item.icon} />
                <span>{item.label}</span>
                <span>
                  {item.loading ? <Spin size="small" /> : `(${item.count})`}
                </span>
              </span>
            ),
            value: item.key,
          }))}
          className="dashboard-columns-select"
          style={{
            width: "140px",
            borderRadius: "8px",
          }}
        />
      ) : (
        rightTabsOptions.map((item) => (
          <Button
            key={item.key}
            className={`sub-tabs-dashboard-button ${activeTabKey === item.key 
              ? "active" 
              : "disabled"}`}
            onClick={() => onChange(item.key)}
          >
            <span className="mobile-table-tab">
              {item.loading ? <Spin size="small" /> : item.count}
            </span>
            <i className={item.icon} />
            <span>{item.label}</span>
          </Button>
        ))
      )}
    </div>
  );
};
